import React from 'react';
export const Problem = () => {
  return <section className="w-full py-16 bg-white" data-id="element-123">
      <div className="container mx-auto px-4 md:px-8" data-id="element-124">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center" data-id="element-125">
          The Sleepless Cycle That Broke Me
        </h2>
        <div className="flex flex-col md:flex-row items-center gap-8 mb-12" data-id="element-126">
          <div className="md:w-1/2" data-id="element-127">
            <p className="text-xl mb-4" data-id="element-128">
              For months, I <span className="font-bold" data-id="element-129">dreaded bedtime</span>.
            </p>
            <p className="text-xl mb-4" data-id="element-130">
              I'd climb into bed at 10:00 PM,{' '}
              <span className="font-bold" data-id="element-131">desperate for rest</span>.
            </p>
            <p className="text-xl mb-4" data-id="element-132">
              By <span className="font-bold" data-id="element-133">2:30 AM</span>, the{' '}
              <span className="font-bold" data-id="element-134">burning would start</span>.
            </p>
            <p className="text-xl mb-4" data-id="element-135">
              It didn't matter which side I turned to.
            </p>
            <p className="text-xl mb-4" data-id="element-136">
              It didn't matter how many pillows I stacked under my leg.
            </p>
            <p className="text-xl mb-4 font-bold" data-id="element-137">
              The stabbing always woke me up.
            </p>
            <p className="text-xl mb-4" data-id="element-138">
              Some nights I'd shuffle around the kitchen,{' '}
              <span className="font-bold" data-id="element-139">waiting for the fire to ease</span>.
            </p>
            <p className="text-xl" data-id="element-140">
              Other nights, I'd sit on the edge of the bed, eyes wide open,{' '}
              <span className="font-bold" data-id="element-141">
                watching the clock tick towards morning
              </span>
              .
            </p>
          </div>
          <div className="md:w-1/2" data-id="element-142">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2GYKNaK4j5cAfKx4Z4AWUz/ChatGPT_Image_1_aug_2025%2C_23_49_08.png" alt="Woman sitting on bed at night in pain" className="rounded-lg shadow-lg w-full" data-id="element-143" />
          </div>
        </div>
        <div className="bg-gray-100 p-8 rounded-lg" data-id="element-144">
          <h3 className="text-2xl font-bold mb-6" data-id="element-145">
            What Everyone Told Me To Do
          </h3>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-146">
            <div data-id="element-147">
              <p className="text-xl mb-3" data-id="element-148">
                The GP said, "
                <span className="font-bold" data-id="element-149">It's just arthritis</span>."
              </p>
              <ul className="list-disc pl-6 mb-4 text-xl" data-id="element-150">
                <li data-id="element-151">Take paracetamol.</li>
                <li data-id="element-152">Try ibuprofen.</li>
                <li data-id="element-153">One even suggested sleeping tablets.</li>
              </ul>
              <p className="text-xl" data-id="element-154">
                I tried gels that{' '}
                <span className="font-bold" data-id="element-155">burned my skin</span>. Ice packs
                that <span className="font-bold" data-id="element-156">soaked my sheets</span>. Braces
                so tight they{' '}
                <span className="font-bold" data-id="element-157">cut off circulation</span>.
              </p>
            </div>
            <div data-id="element-158">
              <p className="text-xl mb-3 font-bold" data-id="element-159">Nothing worked.</p>
              <p className="text-xl mb-3" data-id="element-160">
                Night after night, I was{' '}
                <span className="font-bold" data-id="element-161">still awake</span>.
              </p>
              <p className="text-xl mb-3" data-id="element-162">And the worst part?</p>
              <p className="text-xl mb-3" data-id="element-163">
                Everyone made me feel like it was{' '}
                <span className="font-bold" data-id="element-164">my fault</span>.
              </p>
              <p className="text-xl italic" data-id="element-165">"Maybe you're just sensitive."</p>
              <p className="text-xl italic" data-id="element-166">"Maybe it's your age."</p>
              <p className="text-xl mt-3" data-id="element-167">
                But deep down, I knew{' '}
                <span className="font-bold" data-id="element-168">something was missing</span>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};